// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "swiper/dist/css/swiper.min.css";
import "sweetalert2/dist/sweetalert2.min.css";
import store from './store';
import $ from 'jquery';

import VueSweetalert2 from './plugins/vue-sweetalert2'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueSweetalert2)

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js